import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '@/lib/axios';
import { DashboardProps } from '@/containers/dashboard/Dashboard';
import {useLoadingStore} from '@/stores/loading';
import {useMessageModalStore} from '@/stores/message'
import DashboardCard from './DashboardCard';
import * as Config from '@/config'


interface SummaryData {
  name: string;
  count: number;
}

const History: React.FC<DashboardProps> = ({ projectId, startDate, endDate }) => {
  const setLoading = useLoadingStore(state => state.setLoading);
  const setMessage = useMessageModalStore(state => state.setMessage);

  const [summaryHistory, setSummaryHistory] = useState<SummaryData[]>([]);
  const [summaryBasic, setSummaryBasic] = useState<SummaryData[]>([]);

  const fetchData = useCallback(async (projectCategoryId: number): Promise<SummaryData[]> => {
    const response = await axios.get(`/api/v1/dashboard/areaSummary`, {
      params: {
        project_id: projectId,
        project_category_id: projectCategoryId,
        start_date: startDate,
        end_date: endDate,
      },
    });
    return response.data.summary;
  }, [projectId, startDate, endDate]);

  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      try {
        const [historyData, basicData] = await Promise.all([
          fetchData(Config.PROJECT_CATEGORY_ID_HISTORY),
          fetchData(Config.PROJECT_CATEGORY_ID_BASIC_MAP),
        ]);

        setSummaryHistory(historyData);
        setSummaryBasic(basicData);

      } catch (err) {
        setMessage(Config.MESSAGE_NO_E39);
      } finally {
        setLoading(false);
      }
    };

    loadAllData();
  }, [fetchData, setLoading]);

  return (
    <div className="dashboard-grid">
      {summaryHistory.length > 0 &&
        <DashboardCard title='道路管理管理者更新' label='地整毎の登録数'>
          <table>
            <tbody>
              {summaryHistory.map((summary, index) => (
                <tr key={`${summary.name}_${index}`}>
                  <td className=''>{summary.name}</td>
                  <td>{`${summary.count}件`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DashboardCard>
      }
      {summaryBasic.length > 0 &&
        <DashboardCard title='基盤地図情報更新' label='地整毎の登録数'>
          <table>
            <tbody>
              {summaryBasic.map((summary, index) => (
                <tr key={`${summary.name}_${index}`}>
                  <td>{summary.name}</td>
                  <td>{`${summary.count}件`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DashboardCard>
      }
    </div>
  );
};

export default History;